ARROW_UP_OUTLINE